import Vue from 'vue'
import router from './routes'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import 'normalize.css'
import './assets/global.sass'
import './permission' // control role routes
import sms_button from './components/sms_button'

Vue.use(ElementUI)
Vue.component('sms_button', sms_button)
Vue.directive('zhuge-track', (el, binding) => {
  if (!binding.value.trackname) return
  let f = function (evt) {
    el.removeEventListener('click', f)
    const { trackname, trackother } = binding.value
    if (binding.value.trackother['账号'] === '') return
    zhuge.track(trackname, trackother || {})
  }
  el.addEventListener('click', f)
})

new Vue({
  store,
  el: '#app',
  data () {
    return {
      session: {}
    }
  },
  render: h => h('div', { attrs: {id: 'app'} }, [h('router-view')]),
  created () {
    window.rootApp = this
  },
  router
})




// WEBPACK FOOTER //
// ./src/main.js